import Base from '../Pages/Base'
import ListCategoriasConcursos from '../Pages/Categorias/List'
import FormCategoriasConcursos from '../Pages/Categorias/Form'
import ListConcursos from '../Pages/Concursos/List'
import FormConcursos from '../Pages/Concursos/Form'

export default [
	{
		path: 'servicos/concursos',
		component: Base,
		children: [
			{
				path: '',
				name: 'ListCategoriasConcursos',
				component: ListCategoriasConcursos,
				meta: {
					path: '/servicos/concursos',
					pai: 'Serviços',
					title: 'Admin - Concursos',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Concursos',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			
			{
				path: 'novo',
				name: 'FormCategoriasConcursos',
				component: FormCategoriasConcursos,
				meta: {
					path: '/servicos/concursos',
					pai: 'Serviços',
					title: 'Admin - Concursos - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Concursos',
						class: '',
						active: false,
						url: '/servicos/concursos'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			
			{
				path: 'editar/:id',
				name: 'FormCategoriasConcursosEditar',
				component: FormCategoriasConcursos,
				meta: {
					path: '/servicos/concursos',
					pai: 'Serviços',
					title: 'Admin - Concursos - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Concursos',
						class: '',
						active: false,
						url: '/servicos/concursos'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			
			{
				path: ':id',
				name: 'ListConcursos',
				component: ListConcursos,
				meta: {
					path: '/servicos/concursos',
					pai: 'Serviços',
					title: 'Admin - Concursos - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Concursos',
						class: '',
						active: false,
						url: '/servicos/concursos'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: true,
						url: false,
						newClass: 'menu-selecionado'
					}],
					noCache: true
				},
			},

			{
				path: ':id/novo',
				name: 'FormConcursos',
				component: FormConcursos,
				meta: {
					path: '/servicos/concursos',
					pai: 'Serviços',
					title: 'Admin - Concursos - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Concursos',
						class: '',
						active: false,
						url: '/servicos/concursos'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: false,
						url: '/',
						ref: 'menuSelecionado'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},

			{
				path: ':id/editar/:cat',
				name: 'FormConcursosEditar',
				component: FormConcursos,
				meta: {
					path: '/servicos/concursos',
					pai: 'Serviços',
					title: 'Admin - Concursos - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Concursos',
						class: '',
						active: false,
						url: '/servicos/concursos'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: false,
						url: '/',
						ref: 'menuSelecionado'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
		]
	}
]